import { createSlice } from "@reduxjs/toolkit";

const masterControlSlice = createSlice({
  name: "masterControl",
  initialState: {
    controlStatus: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    setControlStatus(state, action) {
      state.controlStatus = (action.payload || []).map((item) => ({
        name: item.name,
        status: item.is_enabled,
      }));
      state.isLoading = false;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setControlStatus, setLoading, setError } = masterControlSlice.actions;
export default masterControlSlice.reducer;
